// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_DetalheResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /subaccounts/anticipations/detalhe/{id}
 *
 * Returns a single payment_anticipations record enriched with status_info,
 * four `*_display` money fields, and the linked recebimentos list. The shape
 * is declared by SubaccountsAnticipations_DetalheRow.
 *
 * @see anticipations.php::detalhe()
 */
import type { SubaccountsAnticipations_DetalheRow } from './SubaccountsAnticipations_DetalheRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsAnticipations_DetalheResponseDados = SubaccountsAnticipations_DetalheRow;

export type SubaccountsAnticipations_DetalheResponse = ApiResponse<SubaccountsAnticipations_DetalheResponseDados>;

registerResponseContract('SubaccountsAnticipations_DetalheResponse', {
  id:                         { type: 'number',  required: true },
  subaccount_id:              { type: 'number',  required: true },
  payment_link_id:            { type: 'number',  required: false },
  provider_code:              { type: 'string',  required: true },
  provider_anticipation_id:   { type: 'string',  required: true },
  provider_payment_id:        { type: 'string',  required: false },
  provider_installment_id:    { type: 'string',  required: false },
  status:                     { type: 'string',  required: true },
  request_date:               { type: 'string',  required: true },
  anticipation_date:          { type: 'string',  required: false },
  due_date:                   { type: 'string',  required: false },
  anticipation_days:          { type: 'number',  required: false },
  total_value:                { type: 'number',  required: true },
  anticipation_value:         { type: 'number',  required: true },
  fee:                        { type: 'number',  required: true },
  net_value:                  { type: 'number',  required: true },
  denial_observation:         { type: 'string',  required: false },
  is_automatic:               { type: 'number',  required: true },
  created_at:                 { type: 'string',  required: true },
  updated_at:                 { type: 'string',  required: true },
  last_synced_at:             { type: 'string',  required: false },
  status_info: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
  total_value_display:        { type: 'number',  required: true },
  anticipation_value_display: { type: 'number',  required: true },
  fee_display:                { type: 'number',  required: true },
  net_value_display:          { type: 'number',  required: true },
  recebimentos: {
    type: 'array',
    required: false,
    items: {
      recebimento_id:    { type: 'number',  required: true },
      linked_at:         { type: 'string',  required: true },
      linked_by_user_id: { type: 'string',  required: false },
    },
  },
})
